module.exports = __webpack_public_path__ + "img/account1.29ba6863.svg";